var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowToLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03224 0.290325L6.96569 0.21967C6.6773 -0.0506931 6.22351 -0.0714902 5.90968 0.157278L5.83431 0.21967L0.234315 5.46967L0.201197 5.50264L0.157068 5.55352L0.0997369 5.63695L0.0569804 5.7215L0.0286761 5.80051L0.00552573 5.91143L0 6L0.00223029 6.05643L0.0161921 6.15054L0.0397905 6.23411L0.0749387 6.31742L0.116796 6.39053L0.175751 6.46909L0.234315 6.53033L5.83431 11.7803C6.14673 12.0732 6.65327 12.0732 6.96569 11.7803C7.25407 11.51 7.27626 11.0845 7.03224 10.7903L6.96569 10.7197L2.7328 6.75H15.2C15.6418 6.75 16 6.41421 16 6C16 5.58579 15.6418 5.25 15.2 5.25H2.7312L6.96569 1.28033C7.25407 1.00997 7.27626 0.584544 7.03224 0.290325L6.96569 0.21967L7.03224 0.290325Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowToLeft);
export default __webpack_public_path__ + "static/media/ArrowToLeft.5446ba24.svg";
export { ForwardRef as ReactComponent };